import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from 'react';
import type { ConditionPanelHost } from '@/types/advanceFilter';

/**
 * Open/anchor/close plumbing shared by every condition popover. A condition is
 * either hosted — the filter strip owns the popover and anchors it to a chip,
 * so there is no trigger button and the popover is open from mount — or
 * self-managed, where it renders its own trigger and opens on click.
 *
 * The element type parameter is the trigger's, so `triggerRef` stays typed for
 * the button while `anchorRef` widens to whatever the popover anchors to.
 */
export const useConditionPanel = host => {
  const $ = _c(8);
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(!!host);
  const t0 = !!host;
  const t1 = host?.anchorRef ?? triggerRef;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(true);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== host) {
    t3 = () => {
      setIsOpen(false);
      host?.onClose();
    };
    $[1] = host;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isOpen || $[4] !== t0 || $[5] !== t1 || $[6] !== t3) {
    t4 = {
      isHosted: t0,
      isOpen,
      triggerRef,
      anchorRef: t1,
      open: t2,
      close: t3
    };
    $[3] = isOpen;
    $[4] = t0;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};